import { DashboardActionTypes } from './constants';

export type DashboardAction =
    | {
          type: typeof DashboardActionTypes.DASHBOARD_OUTLETS;
      }
    | {
          type: typeof DashboardActionTypes.DASHBOARD_OUTLETS_SUCCESS;
          payload: {
              data: any;
          };
      }
    | {
          type: typeof DashboardActionTypes.DASHBOARD_OUTLETS_ERROR;
          payload: {
              error: string;
          };
      };

export const dashboardOutlets = (): DashboardAction => ({
    type: DashboardActionTypes.DASHBOARD_OUTLETS,
});

export const dashboardOutletsSuccess = (data: any): DashboardAction => ({
    type: DashboardActionTypes.DASHBOARD_OUTLETS_SUCCESS,
    payload: { data },
});

export const dashboardOutletsError = (error: string): DashboardAction => ({
    type: DashboardActionTypes.DASHBOARD_OUTLETS_ERROR,
    payload: { error },
});
